import React, { useMemo, useRef, useImperativeHandle, forwardRef } from 'react';
import {
  CellLeftV8,
  order2Sorting,
  EditCellV8,
  TableCellV8,
  TablePaginatedV8,
  CellYesNoV8,
  CellYesNoEngV8,
} from 'motion-components';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import {
  firstDateUserColumn,
  isActiveColumn,
  lastDateUserColumn,
  gridInactiveRowStyle,
  gridRowSelectedStyle,
} from 'shared-pages/common/grid-helpfunc';

export const DataGrid = forwardRef((props: any, ref) => {
  const {
    data,
    initPageIndex,
    onPageChange,
    loading,
    handleExport,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
    refetch,
    dataCount,
  } = props;

  const location = useLocation<any>();
  const history = useHistory();
  const { appStore, tableStore } = useRootStore();
  const { t, i18n } = useTranslation();

  const columns = useMemo(
    () => [
      {
        id: 'id',
        header: t('ID'),
        accessorKey: 'id',
        orderByField: 'id',
        columnName: t('ID'),
        cell: CellLeftV8,
        size: 10,
      },
      {
        id: 'name',
        header: t('Όνομα Περιφερειακής Ενότητας'),
        accessorKey: 'name',
        orderByField: 'name',
        columnName: t('Όνομα Περιφερειακής Ενότητας'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 40,
      },
      {
        id: 'region',
        header: t('Περιφέρεια'),
        accessorKey: 'region.name',
        orderByField: 'region.name',
        columnName: t('Περιφέρεια'),
        cell: TableCellV8,
        meta: { type: 'text' },
        size: 25,
      },
    ],
    [t, i18n.language],
  );

  const tableRef = useRef(null);

  useImperativeHandle(ref, () => tableRef.current || null);

  return (
    <LoadingOverlay active={loading} spinner text={'Παρακαλώ περιμένετε...'}>
      {data ? (
        <TablePaginatedV8
          ref={tableRef}
          loading={loading}
          id="grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={dataCount}
          onRowClick={(table) => setSelected(table.row.original)}
          rowProps={(row: any) => {
            let style = undefined;
            if (row.original.id === selected?.id) style = gridRowSelectedStyle;
            if (row.original.isActive === false) style = { ...style, ...gridInactiveRowStyle };
            return { style };
          }}
          onExport={handleExport}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          initSorting={order2Sorting(initOrderBy, columns)}
          onSortByChange={(sort, columnDef, orderBy) => {
            onOrderChange(orderBy);
          }}
          topBorderRadius={false}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
  );
});
